var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { CargoActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let CargoModule = class CargoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = CargoActions.POST_CARGO](data) {
        return new Promise(resolve => {
            fornecService.post("Cargo/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = CargoActions.PUT_CARGO](data) {
        return new Promise(resolve => {
            fornecService.put("Cargo/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = CargoActions.DELETE_CARGO](data) {
        return new Promise(resolve => {
            fornecService.delete("Cargo/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = CargoActions.DELETE_RANGE_CARGO](data) {
        return new Promise(resolve => {
            fornecService.delete("Cargo/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = CargoActions.FILTER_CARGO](data) {
        return new Promise(resolve => {
            fornecService.post("Cargo/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = CargoActions.GET_CARGO]() {
        return new Promise(resolve => {
            fornecService.get("Cargo/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = CargoActions.GETWITHDISABLED_CARGO]() {
        return new Promise(resolve => {
            fornecService.get("Cargo/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = CargoActions.GET_BY_ID_CARGO](data) {
        return new Promise(resolve => {
            fornecService.get("Cargo/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CargoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CargoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CargoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CargoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CargoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CargoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CargoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CargoModule.prototype, _h, null);
CargoModule = __decorate([
    Module
], CargoModule);
export default CargoModule;
//# sourceMappingURL=CargoModule.js.map